import { IState } from '../../../store';

export function legacyCalculatorMarkupSelector(state: IState) {
  return state.widgetsMarkup.underMapMarkup;
}
